import React from 'react';
import { EquipmentStatus } from '../../../model/equipment-status';
import { entityManagerProvider } from '../../../model/entity-manager-provider';
import { EntityManager, EntityQuery } from 'breeze-client';
import moment from 'moment';
import { Card, Table } from 'react-bootstrap';
import { Loader } from '@progress/kendo-react-indicators';
interface EquipmentStatusList {
  equipmentStatus: EquipmentStatus[];
  selected: EquipmentStatus;
  ids: number;
  loading: boolean;
  allowAdd: boolean;
}

class EquipmentStatuses extends React.Component<any, EquipmentStatusList> {
  manager: EntityManager;
  constructor(props) {
    super(props);
    this.state = {
      equipmentStatus: [] as EquipmentStatus[],
      selected: null as EquipmentStatus,
      ids: 0 as number,
      loading: true,
      allowAdd: true,
    };
    this.manager = entityManagerProvider.newManager();

    this.saveChanges = this.saveChanges.bind(this);
    this.rejectChanges = this.rejectChanges.bind(this);
    this.addStatus = this.addStatus.bind(this);
    this.remove = this.remove.bind(this);
    this.setTypeState = this.setTypeState.bind(this);
  }

  componentDidMount() {
    entityManagerProvider.subscribeComponent(this.manager, this);

    const query = new EntityQuery('EquipmentStatuses');
    this.manager.executeQuery(query).then((qr) => {
      this.setState({
        selected: null,
        equipmentStatus: qr.results,
        loading: false,
      });
    });
  }
  componentWillUnmount() {
    entityManagerProvider.unsubscribeComponent(this.manager, this);
  }

  addStatus() {
    this.setState({
      ids: this.state.ids - 1,
      allowAdd: false,
    });
    let equipmentStatus = this.manager.createEntity(
      EquipmentStatus.prototype.entityType,
      {
        equipmentStatusId: this.state.ids,
        applicationUserId: this.props.authorizedUser.Id,
      }
    ) as EquipmentStatus;
    // select the new customer, and add it to the list of customers
    this.setState({
      selected: equipmentStatus,
      equipmentStatus: this.state.equipmentStatus.concat([equipmentStatus]),
    });
  }

  remove(ent: EquipmentStatus) {
    ent.entityAspect.setDeleted();
    this.saveChanges();
  }
  dateFormatter(cell) {
    if (!cell) {
      return '';
    }
    return `${
      moment(cell).format('DD-MM-YYYY')
        ? moment(cell).format('DD-MM-YYYY')
        : moment(cell).format('DD-MM-YYYY')
    }`;
  }

  isPaidString(isPaid) {
    if (isPaid) {
      return 'Paid';
    }
    return 'Not Paid';
  }
  saveChanges() {
    this.setState({
      loading: true,
    });
    this.manager
      .saveChanges()
      .then(() => {
        // refresh customer list to remove deleted customers
        this.setState({
          selected: null,
          equipmentStatus: this.manager.getEntities(
            'EquipmentStatus'
          ) as EquipmentStatus[],
        });
      })
      .catch((error) => {
        this.setState({
          selected: null,
          equipmentStatus: this.manager.getEntities(
            'EquipmentStatus'
          ) as EquipmentStatus[],
        });
        console.log('error catch', error, error.entityErrors);
      })
      .finally(() => {
        this.setState({
          loading: false,
          selected: null,
          allowAdd: true,
        });
      });
  }

  rejectChanges() {
    this.manager.rejectChanges();
    // refresh customer list to restore original state
    this.setState({
      selected: null,
      equipmentStatus: this.manager.getEntities(
        'EquipmentStatus'
      ) as EquipmentStatus[],
      allowAdd: true,
    });
  }

  renderPaymentEdit() {
    let equipmentStatus = this.state.selected;
    if (equipmentStatus) {
      return (
        <div>
          <Card border="primary" style={{ width: '100%' }}>
            <Card.Header>
              <button
                className="btn btn-primary ml-2"
                type="button"
                disabled={!this.manager.hasChanges()}
                onClick={this.saveChanges}
              >
                <i className="fa fa-save"></i>
                Save Changes
              </button>
              <button
                className="btn btn-primary ml-2"
                type="button"
                disabled={!this.manager.hasChanges()}
                onClick={this.rejectChanges}
              >
                <i className="fa fa-redo"></i>
                Revert Changes
              </button>
              <button
                className="btn btn-danger ml-2"
                type="button"
                onClick={this.remove.bind(this, equipmentStatus)}
              >
                <i className="fa fa-trash"></i>
                Delete
              </button>
            </Card.Header>
            <Card.Body>
              <form>
                <div className="form-group row">
                  <div className="col-lg-12">
                    <label>Status </label>
                    <input
                      className="form-control"
                      type="text"
                      name="statusName"
                      value={equipmentStatus.statusName || ''}
                      onChange={equipmentStatus.handleChange}
                    />
                  </div>
                </div>
              </form>
            </Card.Body>
          </Card>
        </div>
      );
    }
  }

  setTypeState(type: EquipmentStatus) {
    this.rejectChanges();
    this.setState({ selected: type });
  }
  render() {
    return (
      <div className="card card-custom card-stretch">
        <div className="card-header py-3">
          <div className="card-title align-items-start flex-column">
            <h3 className="card-label font-weight-bolder text-dark">
              Machine Status
            </h3>
            <span className="text-muted font-weight-bold font-size-sm mt-1">
              e.g. Yard, Sea, Received ...
            </span>
          </div>
          <div className="card-toolbar">
            <button
              type="submit"
              className="btn btn-success mr-2"
              onClick={this.addStatus}
              disabled={!this.state.allowAdd}
            >
              Add EquipmentStatus
            </button>
            <button
              type="submit"
              className="btn btn-warning mr-2"
              onClick={() => {
                this.setState({ selected: null, allowAdd: true });
              }}
            >
              Cancel
            </button>
          </div>
        </div>
        <div className="card-body">
          {this.state.loading ? (
            <div className="row" style={{ minHeight: '200px' }}>
              <Loader
                size="large"
                style={{ position: 'relative', margin: '60px auto' }}
                type="converging-spinner"
              />
            </div>
          ) : (
            <div className="row">
              <div className="col-xl-6">
                <div style={{ overflow: 'scroll', height: '300px' }}>
                  <Table className="table" bordered>
                    <thead>
                      <tr>
                        <th>Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.equipmentStatus?.map((type, idx) => {
                        return (
                          <tr
                            key={type.equipmentStatusId}
                            style={{
                              backgroundColor:
                                type === this.state.selected
                                  ? 'lightgray'
                                  : 'white',
                            }}
                            onClick={() => this.setTypeState(type)}
                          >
                            <td>{type.statusName}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>

              <div className="col-xl-6">{this.renderPaymentEdit()}</div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default EquipmentStatuses;
